import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './FacultyIndividual.css';

const FacultyIndividual = () => {
    const [facultyData, setFacultyData] = useState(null);
    const [error, setError] = useState(null);
    const { facultyUsername } = useParams();

    useEffect(() => {
        if (!facultyUsername) return;

        fetch(`http://121.52.154.120:3001/api/faculty/${facultyUsername}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                setFacultyData(data);
            })
            .catch(error => {
                console.error('Fetch error:', error);
                setError(error.toString());
            });
    }, [facultyUsername]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!facultyData) {
        return <div>Loading...</div>;
    }

    return (
        <div className='faculty-individual-detail'>
            <div className='faculty-individual-header'>
                <div className='faculty-individual-container h-12 d-flex flex-column align-items-center justify-content-center text-light'>
                    <h1 className='faculty-individual-title'>{facultyData.name}</h1>
                </div>
            </div>
            <div className='faculty-individual-main my-5'>
                <div className='faculty-individual-profile-container'>
                    {/* Right Column: Basic Details */}
                    <div className='faculty-individual-right-column'>
                        {facultyData?.fimages && (
                            <img
                                src={`http://121.52.154.120:3001${facultyData.fimages}`}
                                alt="Faculty"
                                className="faculty-individual-image"
                            />
                        )}
                        <p className="faculty-individual-multiline-text">
                            <strong>{facultyData?.designation} - {facultyData?.department}</strong>
                        </p>
                        <p className="faculty-individual-multiline-text">{facultyData?.currentPortfolio}</p>
                        <p className="faculty-individual-multiline-text">
                            <strong>Qualification:</strong> {facultyData?.qualification || "Not Available"}
                        </p>
                        <div className="faculty-individual-contact-info">
                            <i className="fas fa-envelope"></i>
                            <span className="faculty-individual-contact-text">
                                <a href={`mailto:${facultyData?.email}`}>{facultyData?.email}</a>
                            </span>
                        </div>
                        <div className="faculty-individual-contact-info">
                            <i className="fas fa-phone"></i>
                            <span className="faculty-individual-contact-text">{facultyData?.phoneNumber}</span>
                        </div>
                    </div>
    
                    <div className='faculty-individual-vertical-line'></div>
    
                    {/* Left Column: Other Details */}
                    <div className='faculty-individual-left-column'>
                        <p>
                            <strong>Biography:</strong>{' '}
                            <span className="faculty-individual-multiline-text">{facultyData.objectives}</span>
                        </p>
                        <hr />
                        <p>
                            <strong>Professional Skills:</strong>{' '}
                            <span className="faculty-individual-multiline-text">{facultyData.professionalSkills}</span>
                        </p>
                        <hr />
                        <p>
                            <strong>Proposed Research Topics:</strong>{' '}
                            <span className="faculty-individual-multiline-text">{facultyData.proposedResearchTopics}</span>
                        </p>
                        <hr />
                        <p>
                            <strong>Research sImpact:</strong>{' '}
                            <span className="faculty-individual-multiline-text">{facultyData.researchImpact}</span>
                        </p>
                        <hr />
                        <h3>Publications</h3>
                        <ul>
                            {facultyData.publications.map((pub, index) => (
                                <li key={index} className="faculty-individual-publication-item">{pub.details}</li>
                            ))}
                        </ul>
                        <hr />
                        <p>
                            <strong>Funded Projects:</strong>{' '}
                            <span className="faculty-individual-multiline-text">{facultyData.fundedProjects}</span>
                        </p>
                        {/* Other sections follow the same pattern */}
                    </div>
                </div>
            </div>
        </div>
    );
};    

export default FacultyIndividual;
